// @ts-nocheck
import React from 'react';
import { stageApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default ({
  filter = {},
  ...selectProps
}) => <AutocompleteSelect fetch={async params => {
  return await stageApi.fetchStage({
    ...filter,
    ...params
  });
}} refetchParams={{
  filter
}} fetchSingle={stageApi.getStage} notFoundText="Этапы не найдены" placeholder="Выберите этап" renderOption={(stage, Option) => <Option key={stage.id} value={stage.id} stage={stage}>
        {`${stage.stageNumber} ${stage.expenseDirection.name}`}
      </Option>} {...selectProps} />;
